import { useState, useCallback } from 'react'

const useFilterValidation = (activeQuestionFilters, activeVariableFilters) => {
  const [fieldErrors, setFieldErrors] = useState({})

  const validateFilters = useCallback(() => {
    const newErrors = {}
    activeQuestionFilters.forEach(filter => {
      if (!filter.questionId)
        newErrors[`question_${filter.uniqueId}`] = 'Veuillez sélectionner une question'

      if (!filter.values?.length)
        newErrors[`values_${filter.uniqueId}`] = 'Veuillez sélectionner au moins une réponse'
    })

    activeVariableFilters.forEach(filter => {
      if (!filter.variableId)
        newErrors[`variable_${filter.uniqueId}`] = 'Veuillez sélectionner une variable'

      if (!filter.values?.length)
        newErrors[`variable_values_${filter.uniqueId}`] = 'Veuillez sélectionner au moins une valeur'
    })

    setFieldErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }, [activeQuestionFilters, activeVariableFilters])

  const clearError = useCallback(errorKey => {
    setFieldErrors(prev => {
      const newErrors = { ...prev }
      delete newErrors[errorKey]
      return newErrors
    })
  }, [])

  const clearAllErrors = useCallback(() => {
    setFieldErrors({})
  }, [])

  return {
    fieldErrors,
    validateFilters,
    clearError,
    clearAllErrors
  }
}

export default useFilterValidation